export enum ConversationTypeEnum {
  PLAIN_MESSAGE = 'PLAIN_MESSAGE',
  PROJECT_MESSAGE = 'PROJECT_MESSAGE',
}
